// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__kKEW0","logo":"Header_logo__UsziS"};